import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";

const IconHoverBadge = ({id, scheme, icon, desc, selected, clickHandler}) => {

    const [hover, setHover] = useState(false);

    // default scheme
    let bg = "bg-light";
    let bgSelected = "bg-energo";
    let border = "border-energo";
    let textColor = "text-energo";
    let textColorSelected = "text-light";

    // scheme color
    if (scheme === "energo") {
        bgSelected = "bg-success";
        border = "border-energo";
        textColor = "text-success";
    }
    if (scheme === "primary") {
        bgSelected = "bg-primary";
        border = "border-primary";
        textColor = "text-primary";
    }
    if (scheme === "warning") {
        bgSelected = "bg-warning";
        border = "border-warning";
        textColor = "text-warning";
        textColorSelected = "text-dark";
    }

    return (
        <Badge
            onClick={() => clickHandler !== undefined? clickHandler() : null}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            id={id}
            className={hover? `${bgSelected} ${textColorSelected} shadow-lg`: `${bg} ${textColor} ${border}`}
            style={{marginRight: 5, marginBottom: 5, width: "auto", border: "1px solid", cursor: "pointer"}}
        >
            <Row className="align-items-center">
                <Col xs="2">{icon}</Col>
                <Col xs={hover? "8": "10"}>{desc}</Col>
                <Col xs="2" className="text-danger" hidden={!hover}>x</Col>
            </Row>
        </Badge>
    )
}
export default IconHoverBadge;